import { stocklistConstants } from '../../constants';

export default function setViewingUserId(userId) {
  return {
    type: stocklistConstants.SET_VIEWING_USER,
    userId,
  };
}
